// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"102":"xlsx","133":"pdfmake","182":"canvg"}[chunkId] + "." + {"102":"1f9bcf54","133":"4d48a216","182":"7aa8db67"}[chunkId] + ".chunk.js";
};